// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { BehaviourTutorialBaseService } from './behaviour-tutorial-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class BehaviourTutorialService extends BehaviourTutorialBaseService {
}
